import { createFileRoute } from "@tanstack/react-router"
import { CompanyDetailsPage } from "@/components/dashboard/admin/pages/companies/CompanyDetailsPage"

export const Route = createFileRoute("/companies/$companyId")({
  component: CompanyDetailRoute,
})

function CompanyDetailRoute() {
  const { companyId } = Route.useParams()
  return <CompanyDetailsPage companyId={companyId} />
}
